import * as swcHelpers from '@swc/helpers';
import { useCurrentRefinements } from 'react-instantsearch-core';
import { useLocation } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { useAlgoliaConfig } from '../Algolia/AlgoliaConfig.js';

const useFacets = ()=>{
    const { getLabel  } = useIntl();
    const { facets  } = useAlgoliaConfig();
    const { pathname  } = useLocation();
    const isProductCategoryPage = !pathname.startsWith('/search');
    const excludedAttributes = isProductCategoryPage ? [
        'filterableAttributes.productType'
    ] : [];
    const { items  } = useCurrentRefinements({
        excludedAttributes
    });
    const appliedFacets = items.reduce((acc, item)=>{
        const facet1 = facets.find((facet)=>facet.attribute === item.attribute
        );
        if (facet1) {
            const label = facet1.labelKey ? getLabel(facet1.labelKey) : (facet1 === null || facet1 === void 0 ? void 0 : facet1.id) || '';
            const facetKey = facet1.id || '';
            return swcHelpers.objectSpread({}, acc, {
                [facetKey]: {
                    label,
                    value: item.refinements.map((refinement)=>refinement.value.toString()
                    )
                }
            });
        } else {
            return acc;
        }
    }, {});
    const numberOfAppliedFacets = Object.values(appliedFacets).flatMap((facet)=>facet.value
    ).length;
    return {
        appliedFacets,
        numberOfAppliedFacets
    };
};

export { useFacets };
//# sourceMappingURL=use-facets.js.map
